import React from "react";
import { Popover } from "@typeform/embed-react";

const SurveyWidget = () => {
  return <Popover id="IXO2eJuk" className={"typeform-survey-button"} />;
};

export default SurveyWidget;
